import React from 'react';
import { enqueueSnackbar } from 'notistack';
import { HealtheraButton } from '../../../../healtheraComponents';
import { ClinicFormAndIdProps } from '../../CreateClinic/types';
import useUpdateClinic from '../hooks/useUpdateClinic';
import { StyledPaperContainer } from '../../../PlusWebsiteEditor/PlusWebsiteEditor.styles';
import { StyledButtonsContainer } from '../../../Questionnaires/QuestionnairePage/components/QuestionViewerEditor/QuestionEditor/styles';
import { ClinicWithConditionsAndPromo } from '../../types';
import { SubmitErrorHandler } from 'react-hook-form';
import styled from 'styled-components';

const ModifyClinicFooter = ({ form, clinicId }: ClinicFormAndIdProps) => {
  return (
    <StickyPaperContainer>
      <StyledButtonsContainer>
        <SaveClinicConditionsButton clinicId={clinicId} form={form} />
      </StyledButtonsContainer>
    </StickyPaperContainer>
  );
};

const StickyPaperContainer = styled(StyledPaperContainer)`
  && {
    position: sticky;
    bottom: 0;
    z-index: 2;
    border-top: 1px solid #e0e0e0;
    border-radius: 13px 13px 0 0;
  }
`;

const SaveClinicConditionsButton = ({ clinicId, form }: ClinicFormAndIdProps) => {
  const { handleSave, isLoading } = useHandleSaveUpdate({ clinicId, form });

  const isAnyFieldChanged = form.formState.isDirty;
  const shouldDisableSave = isLoading || !isAnyFieldChanged;

  const handleInvalidForm: SubmitErrorHandler<ClinicWithConditionsAndPromo> = () => {
    enqueueSnackbar('Please fill in all required fields', { variant: 'error' });
  };

  return (
    <HealtheraButton disabled={shouldDisableSave} onClick={form.handleSubmit(handleSave, handleInvalidForm)}>
      Save
    </HealtheraButton>
  );
};

const useHandleSaveUpdate = ({ clinicId, form }: ClinicFormAndIdProps) => {
  const { updateClinic, isLoading } = useUpdateClinic();

  const handleSave = async () => {
    const updatedFields = form.getValues();

    await updateClinic([clinicId, updatedFields]);

    enqueueSnackbar('Clinic updated', { variant: 'success' });
  };

  return { handleSave, isLoading };
};

export default ModifyClinicFooter;
